import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bad494c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header-stripe" }
const _hoisted_2 = { class: "version-info" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_grid = _resolveComponent("grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_button_bar = _resolveComponent("button-bar")!
  const _component_simple_keyboard = _resolveComponent("simple-keyboard")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.data && _ctx.data.classnames ? _ctx.data.classnames : '')
  }, [
    _createVNode(_component_ion_page, { onMousedown: _ctx.handlePageClick }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, "Version: " + _toDisplayString(_ctx.versionInfo()), 1),
          _createElementVNode("img", {
            src: _ctx.getLogo()
          }, null, 8, _hoisted_3)
        ]),
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "container",
              class: _normalizeClass({ 'vertical-center': _ctx.data && _ctx.data.vcenter, fullheight: _ctx.fullheight })
            }, [
              _createElementVNode("form", null, [
                _createVNode(_component_grid, { stepdata: _ctx.data }, null, 8, ["stepdata"])
              ])
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_footer, null, {
          default: _withCtx(() => [
            _createVNode(_component_button_bar, { stepdata: _ctx.data }, null, 8, ["stepdata"]),
            (_ctx.forceKeyboard && _ctx.focussedFieldname)
              ? (_openBlock(), _createBlock(_component_simple_keyboard, {
                  key: 0,
                  onOnChange: _ctx.simpleKeyboardChange,
                  onOnKeyPress: _ctx.simpleKeyboardKeyPress,
                  input: _ctx.focussedFieldValue
                }, null, 8, ["onOnChange", "onOnKeyPress", "input"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onMousedown"])
  ], 2))
}